import { Slide01Title } from './Slide01Title'
import { SlideEnterpriseScale } from './SlideEnterpriseScale'
import { SlideReferenceCampaignJourney } from './SlideReferenceCampaignJourney'
import { SlideReferenceEveryChannel } from './SlideReferenceEveryChannel'
import { SlideReferenceCampaignCalendar } from './SlideReferenceCampaignCalendar'
import { SlideReferenceDesignLogic } from './SlideReferenceDesignLogic'
import { SlidePortfolioCostCalculator } from './SlidePortfolioCostCalculator'
import { Slide17Closing } from './Slide17Closing'

export const slides = [
  SlidePortfolioCostCalculator,
  Slide01Title,
  SlideEnterpriseScale,
  SlideReferenceCampaignJourney,
  SlideReferenceEveryChannel,
  SlideReferenceCampaignCalendar,
  SlideReferenceDesignLogic,
  Slide17Closing,
]

export const slideTitles: { section: string; title: string }[] = [
  { section: 'Opening', title: 'The Campaign Cost Disruptor' },
  { section: '02', title: 'Lundbeck Snakker Campaign Suggestion' },
  { section: '03', title: 'Meet Snakker' },
  { section: '04', title: 'Each Campaign Becomes an Interactive Journey' },
  { section: '05', title: 'One Campaign, Every Relevant Channel' },
  { section: '06', title: 'A Calendar, Not a Campaign-by-Campaign Ask' },
  { section: '07', title: 'What Is a Snak?' },
  { section: '08', title: 'Closing Recommendation' },
]
